module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_block"
  }, [_c('div', {
    staticClass: "foot"
  }, [_c('h2', [_vm._v("CONTACT")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.footer_name)
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.header_address)
    }
  }), _c('p', [_c('a', {
    attrs: {
      "href": "tel:" + _vm.props.data.acf.header_phone_number,
      "itemprop": "telephone"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.header_phone_number)
    }
  })]), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:" + _vm.props.data.acf.footer_mail,
      "itemprop": "email"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.footer_mail)
    }
  })])]), _c('div', {
    staticClass: "foot"
  }, [_c('h2', [_vm._v("CONNECT")]), _c('div', {
    staticClass: "footer-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.props.data.acf.yelp,
      "target": "blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.data.acf.yelp_image,
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": _vm.props.data.acf.twitter,
      "target": "blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.data.acf.twitter_image,
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": _vm.props.data.acf.instagram,
      "target": "blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.data.acf.instagram_image,
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": _vm.props.data.acf.facebook,
      "target": "blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.data.acf.facebook_image,
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "foot"
  }, [_c('h2', [_vm._v("OPPORTUNITY")]), _c('div', {
    staticClass: "opportunity",
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.footer_column_three)
    }
  })])]), _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v("© " + _vm._s(new Date().getFullYear()) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.copyright_text)
    }
  })]), _c('p', {
    staticClass: "home-foot",
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.after_copyright_content)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1766457a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 533
// module chunks = 1